import { render, staticRenderFns } from "./QuestionTemplatesListPage.vue?vue&type=template&id=7893332f&scoped=true&"
import script from "./QuestionTemplatesListPage.vue?vue&type=script&lang=ts&"
export * from "./QuestionTemplatesListPage.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionTemplatesListPage.vue?vue&type=style&index=0&id=7893332f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7893332f",
  null
  
)

export default component.exports